module.exports = __webpack_public_path__ + "static/media/blog_53.bb955f4b.webp";